import {
  overParseJson,
  checkAttendantAndFetch,
} from '../utils/requestUtils';

const CONTACT_API_URL = 'https://blog.afiliados.uol.com.br/contato/contact.php';
const HTTP_ERROR = 'HTTP_ERROR';

class ContactApi {
  static async send(formData) {
    const fd = new FormData();
    fd.append('name', ['Nome: ', formData.name, 0]);
    fd.append('email', ['E-mail', formData.email, 1]);
    fd.append('campaign', formData.campaign);
    fd.append('contactReason', ['Motivo do Contato', formData.contactReason, 4]);
    fd.append('subject-detail', ['Problema', formData['subject-detail'], 5]);
    fd.append('message', ['Descri&ccedil;&atilde;o do Problema', formData.message, 6]);
    if (!formData.namLogin) {
      fd.append('namLogin', ['Login', 'N&atilde;o informado', 2]);
      fd.append('subject', `${formData.campaign} - ${formData.contactReason}`);
    } else {
      fd.append('namLogin', ['Login', formData.namLogin, 2]);
      fd.append('subject', `${formData.campaign} - [${formData.namLogin}] - ${formData.contactReason}`);
    }
    fd.append('signature', 'Enviado de Formul&aacute;rio de Contatos UOL Afiliados');
    fd.append('attachment', formData.attachment);
    fd.append('lang', 'pt-br');
    fd.append('send', 'ok');
    try {
      const fetchResponse = await checkAttendantAndFetch(`${CONTACT_API_URL}`, {
        method: 'POST',
        credentials: 'same-origin',
        body: fd,
      });
      const text = await fetchResponse.text();
      const data = overParseJson(text);

      if (fetchResponse.status !== 200) {
        const error = new Error(data.error);
        error.code = HTTP_ERROR;
        error.status = fetchResponse.status;
        throw error;
      }
      return data;
    } catch (error) {
      throw error;
    }
  }
}

export default ContactApi;
